.button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 16px;
  gap: 6px;
  border: 1px solid var(--neutral-600, #d9d9d9);
  border-radius: var(--border-radius-sm, 4px);
  background: transparent;
  color: var(--neutral-600, #0E0E0E);
  cursor: pointer;
  transition: background-color 200ms ease, color 200ms ease;
  font-size: var(--font-size-sm, 14px);
  font-weight: var(--font-weight-regular, 400);
}
.button:hover {
  background: var(--neutral-100, #F5F5F5);
}
.button.active {
  background: var(--neutral-600, #0E0E0E);
  color: #FFFFFF;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL3BhZ2VzL0Rhc2hib2FyZC9mcmFnbWVudHMvSGVhZGVyL2NvbXBvbmVudHMvRmlsdGVyc0J1dHRvbiIsInNvdXJjZXMiOlsiRmlsdGVyc0J1dHRvbi5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUVBO0VBQ0E7RUFDQTtFQUVBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUVBO0VBQ0E7O0FBRUE7RUFDRTs7QUFHRjtFQUNFO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIuYnV0dG9uIHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG5cbiAgaGVpZ2h0OiAzNnB4O1xuICBwYWRkaW5nOiAwIDE2cHg7XG4gIGdhcDogNnB4O1xuXG4gIGJvcmRlcjogMXB4IHNvbGlkIHZhcigtLW5ldXRyYWwtNjAwLCAjZDlkOWQ5KTtcbiAgYm9yZGVyLXJhZGl1czogdmFyKC0tYm9yZGVyLXJhZGl1cy1zbSwgNHB4KTtcbiAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG4gIGNvbG9yOiB2YXIoLS1uZXV0cmFsLTYwMCwgIzBFMEUwRSk7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgdHJhbnNpdGlvbjogYmFja2dyb3VuZC1jb2xvciAyMDBtcyBlYXNlLCBjb2xvciAyMDBtcyBlYXNlO1xuXG4gIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLXNtLCAxNHB4KTtcbiAgZm9udC13ZWlnaHQ6IHZhcigtLWZvbnQtd2VpZ2h0LXJlZ3VsYXIsIDQwMCk7XG5cbiAgJjpob3ZlciB7XG4gICAgYmFja2dyb3VuZDogdmFyKC0tbmV1dHJhbC0xMDAsICNGNUY1RjUpO1xuICB9XG5cbiAgJi5hY3RpdmUge1xuICAgIGJhY2tncm91bmQ6IHZhcigtLW5ldXRyYWwtNjAwLCAjMEUwRTBFKTtcbiAgICBjb2xvcjogI0ZGRkZGRjtcbiAgfVxufSJdfQ== */